import React, { Component } from "react";
import { withTranslation, Trans } from "react-i18next";
import { v4 as uuidv4 } from "uuid";
import swal from "sweetalert";
import classnames from "classnames";
import serialize from "form-serialize";
import Paper from "@material-ui/core/Paper";
import Grid from "@material-ui/core/Grid";
import Card from '@material-ui/core/Card';
import Button from "@material-ui/core/Button";
import FormGroup from "@material-ui/core/FormGroup";
import Input from "@material-ui/core/Input";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import LockOpenIcon from "@material-ui/icons/LockOpen";
import FormControl from "@material-ui/core/FormControl";
import imgUrl from "../../assets/images/imageUrl.js";
import TextField from "@material-ui/core/TextField";
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import MenuItem from '@material-ui/core/MenuItem';
import ListItemText from '@material-ui/core/ListItemText';
import Select from '@material-ui/core/Select';
import Loader from "../loaders/loader";
import { connect } from "react-redux";
import { useHistory, withRouter, Route, Redirect, Switch, Link } from "react-router-dom";
import { withStyles, makeStyles, useTheme, withTheme } from "@material-ui/core/styles";
import { signInAnonymously } from "../../helpers/auth";
import { auth } from "../../service/firebase";
import { db, storageRef } from "../../service/firebase";
import ApiServices from "../../api/api";
import UserProfileQuestionnaire from "./UserProfileQuestionnaire";
import OffileDb from '../../config/pouchDB';
import { gaLogEvent } from "../../helpers/analytics";
import cordovaConfig from '../../config/cordovaConfig';

let userType = '';
let age = '';
let gender = '';
let Nickname = '';
let checkvalidation = true;
let dependentQueSet = [];

class UserProfile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      lat: '',
      lng: '',
      userDetails: [],
      questionlist: []
    };
    this.handleSubmit = this.handleSubmit.bind(this)
    this.saveApplicantdeatils = this.saveApplicantdeatils.bind(this)
  }


  componentDidMount() {
    gaLogEvent("Settings User Profile", '', '');
    dependentQueSet = [];
    this.getCurrentLocation()
    this.getUserDeatils()
    this.getRegistrationForm()
    cordovaConfig.init();
  }

  getCurrentLocation() {
    var that = this;
    var options = {
      enableHighAccuracy: true,
      timeout: 5000,
      maximumAge: 0,
    };
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        function (position) {
          that.setState({
            lat: position.coords.latitude,
            lng: position.coords.longitude,
          });
        },
        null,
        options
      );
    }
  }


  getRegistrationForm() {

    var param = {
      communityId: this.props.communityuid,
      languageId: this.props.langId,
    };
    console.log(param)

    ApiServices.getRegistrationQuestions(param).then((data) => {
      try{
        if (data.data.status == 200) {
          if (data.data.data.length > 0) {
            this.setState({
              questionlist: data.data.data,
            });
          }
        }
      }catch(err){
        console.log("Error::", err);
      }
    });

    // var param = {
    //   communityId: this.props.communityuid,
    //   languageId: this.props.langId,
    //   contentId: 73,
    // };
    // ApiServices.getStaticContent(param).then((data) => {
    //   if (data.data.status == 200) {
    //     this.setState({
    //       questionlist: data.data.data.contentList[0].questionList,
    //     });
    //   }
    // });
  }

  getUserDeatils() {
    var param = {
      "communityId": this.props.communityuid,
      "userId": JSON.parse(localStorage.getItem('obj')).userId
    }
    ApiServices.getUserProfile(param).then((res) => {
      if (res.status == 200) {
        console.log(res.data.data)
        this.setState({ userDetails: res.data.data, isLoading: false });
      }
    });
  }


  getRegistrationInfo() {

    var registList = []
    this.state.questionlist.map(qobj => {
      var obj = qobj.questionList[0]
      var selectValue = obj.type == "checkbox" ? [] : '';
      if (this.state.userDetails.registrationInfoList != null) {
        selectValue = this.getSeelectedValues(obj)
        var reginfo = this.state.userDetails.registrationInfoList.registrationInfo.filter(o => o.questionId == obj.questionId)
      }
      registList.push(this.renderQuestion(obj, selectValue))

      if (reginfo && reginfo.length > 0) {
        this.getDependentQuestion(obj, selectValue, reginfo)
      }
    })


    dependentQueSet = dependentQueSet.filter((thing, index, self) =>
      index === self.findIndex((t) => (
        t.key === thing.key
      ))
    )

    registList.push(...dependentQueSet)
    return registList
  }

  getDependentQuestion(element, selectValue, reginfo) {
    if (element.dependentQuestionsList && reginfo) {
      var dependentQueObj = element.dependentQuestionsList.filter(o => o.selectedOption == selectValue)
      if (dependentQueObj.length > 0) {
        dependentQueObj.map((element2) => {
          var depenObj = reginfo[0].dependentQuestionsList.filter(o => o.questionId == element2.questionId)
          if (depenObj.length > 0) {
            var dselectValue = this.getSeelectedDependantValues(depenObj)
            dependentQueSet.push(this.renderQuestion(element2, dselectValue));
            this.getDependentQuestion(element2, dselectValue, depenObj)
          }

        })
      }
    }
  }

  getSeelectedValues(obj) {
    var reginfo = this.state.userDetails.registrationInfoList.registrationInfo.filter(o => o.questionId == obj.questionId)
    if (reginfo.length > 0) {
      return obj.type == "checkbox" ? [...new Set(reginfo[0]['response'])] : reginfo[0]['response'][0]
    } else {
      return obj.type == "checkbox" ? [] : '';
    }
  }

  getSeelectedDependantValues(depenObj) {
    if (depenObj.length > 0) {
      return depenObj[0].type == "checkbox" ? [...new Set(depenObj[0]['response'])] : depenObj[0]['response'][0]
    } else {
      return depenObj[0].type == "checkbox" ? [] : '';
    }
  }

  handleSubmit(event) {
    event.preventDefault();
    checkvalidation = true;
    let { questionlist } = this.state;
    const { t } = this.props;
    const form = event.target;
    var str = serialize(form);
    var obj = serialize(form, { hash: true });
    var Qtype = ['radio','checkbox','dropdown']
    if (Object.keys(obj).length == 0) {
      swal({
        title: t("Please atleast one option"),
        icon: "error",
        button: "Ok",
      })
      return;
    }

    console.log(obj);
    let registrationInfo = [];

    questionlist.map(qobj => {
      var questionobj = qobj['questionList'][0]
     
      
      if (obj[questionobj.questionId]) {
        var questName = questionobj.name.trim()
        /*start condition for usertype */
        var qname = questionobj.name.toLowerCase()
        if (qname == "age") {
          age = Qtype.includes(questionobj.type.toLowerCase()) ? questionobj.optionMap[obj[questionobj.questionId]] : obj[questionobj.questionId]
        }

        if (qname == "gender" || qname == 'sex') {
          gender = Qtype.includes(questionobj.type.toLowerCase()) ? questionobj.optionMap[obj[questionobj.questionId]] : obj[questionobj.questionId]
        }

        if (questionobj.name == "usertype" || questionobj.name == 'userrole') {
          let selectedUserType = questionobj.optionMap[obj[questionobj.questionId]]
          userType = selectedUserType;
        }

        if (qname == "nickname") {
          Nickname = Qtype.includes(questionobj.type.toLowerCase()) ? questionobj.optionMap[obj[questionobj.questionId]] : obj[questionobj.questionId]
        }

        // if(questionobj.questionId == 5) {
        //   obj[questionobj.questionId] = obj[questionobj.questionId].split(',')
        // } 

        /*end condition for usertype */
        if (Array.isArray(obj[questionobj.questionId])) {
          questionobj['response'] = obj[questionobj.questionId]
        } else {
          questionobj['response'] = Qtype.includes(questionobj.type.toLowerCase())? [...new Set(obj[questionobj.questionId].split(','))] : [obj[questionobj.questionId]]
        }

        if (questionobj.isValidation) {
          this.checkValidation(questionobj)
        }

        if (questionobj.dependentQuestionsList) {
          this.checkDependentResponsed(questionobj, obj)
        }

        questionobj.questionType = questionobj.type
        registrationInfo.push(questionobj)
      }
    })
    this.saveApplicantdeatils(registrationInfo, userType, age, gender, Nickname);

  }

  checkDependentResponsed(questionobj, obj) {
    if (questionobj.dependentQuestionsList) {
      questionobj.dependentQuestionsList = this.getDependentResponse(questionobj.dependentQuestionsList, questionobj.questionId, obj)
      if (questionobj.dependentQuestionsList) {
        questionobj.dependentQuestionsList.forEach(q => {
          this.checkDependentResponsed(q, obj)
        })

      }
    }
  }

  getDependentResponse(depenArr, parantid, formObj) {
    var arr = []
    console.log(depenArr, parantid, formObj);
    depenArr.forEach(obj => {

      obj.questionType = obj.type;

      if (obj.name == "age" || obj.name == "Age") {
        age = obj.optionMap[formObj[obj.questionId]]
      }

      if (obj.name == "gender" || obj.name == "Gender" || obj.name == "sex" || obj.name == "Sex") {
        gender = obj.optionMap[formObj[obj.questionId]]
      }

      if (obj.name == "usertype" || obj.name == 'userrole') {
        let selectedUserType = obj.optionMap[formObj[obj.questionId]]
        userType = selectedUserType;
      }

      var id = obj.questionId
      if (formObj[id] != undefined) {
        obj.response = [formObj[id]]
        arr.push(obj)
      }

      if (obj.isValidation) {
        this.checkValidation(obj)
      }
    })
    return arr;
  }

  checkValidation(questionobj) {
    console.log(questionobj)
    if (questionobj.validations != null && questionobj.validations.length > 0) {
      if (questionobj.validations[0].validationType == "Verify") {
        if (questionobj.response != undefined && questionobj.validations[0].validationValues[1] != questionobj.response[0]) {
          checkvalidation = false;
        }
      }
    }
  }

  saveApplicantdeatils(registrationInfo, userType, age, gender, Nickname) {
    let uuid = uuidv4();
    const { t } = this.props;
    localStorage.setItem("deviceuuid", uuid);
    let params = {
      communityId: this.props.communityuid,
      // deviceDetails: {
      //   serialNumber: uuid,
      // },
      preferredLanguageId: this.props.langId,
      profile: {
        age: age,
        gender: gender,
        nickName: Nickname,
        location: {
          coordinates: [this.state.lat, this.state.lng],
          type: "point",
        },
      },
      registrationInfoList: {
        registrationInfo: registrationInfo,
        languageId: parseInt(this.props.langId)
      },
      userId: JSON.parse(localStorage.getItem('obj')).userId,
      geoLocation: false
    }

    if (checkvalidation) {
      params.userType = userType;
    }

    // param.profile = Object.assign({}, obj, param.profile);
    console.log(params);
    ApiServices.updateApplicant(params).then((res) => {
      try{
        if (res.data.status == 200) {
          localStorage.setItem('obj', JSON.stringify({
            roleId: res.data.data.roleId,
            roleType: res.data.data.roleType,
            userId: res.data.data.userId,
            userType: res.data.data.userType,
          }))
          swal({
            title: t("Successfully updated"),
            icon: "success",
            button: t("ok"),
          }).then((val) => {
            this.props.history.push("/layout/settings");
          });
        }
      }catch(err){
        console.log("Error::", err);
      }
    });
    if(Nickname) {
      signInAnonymously().then((res) => {
        auth().onAuthStateChanged((user) => {
          if (user) {
            user.updateProfile({
              displayName: Nickname,
            }).then(function (res) {
                console.log("updateProfile res>>", res);
              }).catch(function (error) {
                console.log("updateProfile error>>", error);
              });
          } else {
            console.log("error>>", user);
          }
        });
      }).catch((err) => console.log("err>>>", err));
    }

  }

  renderQuestion(element, selectValue) {    
    // myrights specific field(network code) hidden for guest user
    if(JSON.parse(localStorage.getItem('obj')).userType == "GuestUser" && element.id == 484){
      return false;
    }

    const { templateID } = this.props;
    return (
      <Card key={element.questionId} className="mb-20px userProfileCard">
        <Grid
          container
          spacing={0}
          className="gridcontainer chatuserlistdiv"
        >
          <Grid item xs={12}>
            <p className={templateID ==1 ? "zero chatusername" : "zero color-green chatusername"}>{element.question}</p>
          </Grid>
          <Grid item xs={12}>
            <div className="userprofilefieldset">
              <FormControl component="fieldset">
                <FormGroup>
                  {/* {element['response'].map((o) => {
                  return <span>{element.optionMap[o]}</span>;
                })} */}
                  <UserProfileQuestionnaire element={element} selectValue={selectValue}></UserProfileQuestionnaire>
                </FormGroup>
              </FormControl>
            </div>
          </Grid>
        </Grid>
      </Card>
    );
  }




  render() {
    const { t } = this.props;
    const { templateID } = this.props;
    if (!this.state.isLoading) {
      var regiIno = this.getRegistrationInfo()
    }

    return (
      <div className="gk-page getknowledgeable_page">

        {
          templateID == 1 && (
            <div className="backgroundivholder">
              <div className="bgdiv1">
                <div class="welcometopcurve">
                  <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
                    <path d="M600,112.77C268.63,112.77,0,65.52,0,7.23V120H1200V7.23C1200,65.52,931.37,112.77,600,112.77Z" class="shape-fill"></path>
                  </svg>
                </div>
              </div>
              <div className="bgdiv2"></div>
            </div>
          )
        }

        <div className="gridcontainer">
          <Grid container spacing={3} className="gridcontainer">
            <Grid item xs={12} className="gkdivcontent zero">
              <div className="text-center userProfileHeading"> {t('User profile')} </div>
              <div className="forumlistdivholder userprofileholder">
                {this.state.isLoading ? (
                  <Loader isLoading={this.state.isLoading} />
                ) : this.state.userDetails.length == 0 ? (
                  <p>{t('No Data Found')}</p>
                ) : (
                  <form id="surveyform" onSubmit={this.handleSubmit}>
                    {regiIno}
                    <div className="text-center reportsubmitbtn-divholder">
                      <Button
                        type="submit"
                        variant="contained"
                        color="primary"
                        disableElevation
                        className="userProfilesubmitbtn"
                      >
                        {t('submit')}
                      </Button>
                    </div>
                  </form>

                )}
              </div>
            </Grid>
          </Grid>
        </div>
      </div>
    );
  }
}


const mapStateToProps = (state) => {
  let { storeState } = state;
  return {
    templateID: JSON.parse(localStorage.getItem('templateID')) != null ? JSON.parse(localStorage.getItem('templateID')) : storeState.templateID,
    communityuid: storeState.communityId,
    langId: storeState.langId,
    selectedComponentObj: storeState.componentObj,
  };
};

const transUserProfile = withTranslation()(UserProfile);
const themeUserProfile = withTheme(transUserProfile);
const routeUserProfile = withRouter(themeUserProfile);
export default connect(mapStateToProps, {})(routeUserProfile);
